/* ==========================================================================
   RYSE . adicao rapida pelo menu
   --------------------------------------------------------------------------
   Um botao redondo por produto. Quem esta no menu ja decidiu o que quer; ir
   ate a PDP pra clicar em outro botao e um desvio que so existe porque a
   lista nao sabia vender.

   ELE NAO CHAMA O CARRINHO DIRETAMENTE. Faz o POST em /cart/add.js e pronto -
   o barramento do ryse-carrinho.js embrulha fetch e XHR, entao a bolha do
   icone, a barra flutuante e o painel se atualizam sozinhos, e o aviso
   "entrou na bolsa" aparece pelo mesmo caminho de sempre. Um caminho so pra
   "algo entrou" e o que impede dois lugares discordarem sobre o que ha na
   bolsa.

   --------------------------------------------------------------------------
   O MOVIMENTO, e por que cada numero

   Tres estados no mesmo botao, com os icones empilhados na mesma celula e
   alternando opacidade - a mesma gramatica do campo de CEP, de proposito:
   dois jeitos diferentes de dizer "estou trabalhando" no mesmo painel fariam
   a pessoa aprender duas coisas.

     parado     o "+"
     ocupado    o anel girando (linear, 700ms - constante nao hesita)
     ok         o check, por 1.4s, e volta sozinho

   O VOLTAR SOZINHO importa: um botao que fica verde pra sempre deixa de ser
   botao e vira etiqueta, e a pessoa nao sabe se pode tocar de novo. 1.4s e o
   tempo de ler o check sem ficar esperando por ele.

   PRESSAO: scale(.9) em 160ms - a faixa de feedback de toque. Mais lento que
   isso e a mao ja saiu quando a animacao comeca.
   ========================================================================== */
(function () {
  if (window.__ryseMenuAdd) return;
  window.__ryseMenuAdd = true;

  var VOLTA = 1400;

  /* guarda o relogio POR BOTAO: com um relogio global, adicionar dois
     produtos seguidos faria o segundo herdar o tempo que sobrou do primeiro */
  var relogios = new WeakMap();

  function estado(b, v) {
    b.dataset.estado = v || '';
    clearTimeout(relogios.get(b));
    if (v === 'ok') {
      relogios.set(b, setTimeout(function () { b.dataset.estado = ''; }, VOLTA));
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rmn-poe]');
    if (!b) return;

    e.preventDefault();
    if (b.dataset.estado === 'ocupado') return;   // toque duplo nao vira dois itens

    var id = b.dataset.rmnPoe;
    if (!id) return;

    estado(b, 'ocupado');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add falhou: ' + r.status);
        return r.json();
      })
      .then(function () { estado(b, 'ok'); })
      .catch(function () {
        /* o erro volta o botao ao repouso em vez de pintar de vermelho: numa
           lista de produtos, vermelho parece defeito DO PRODUTO. Quem precisa
           explicar uma falha de rede e o painel, nao a miniatura. */
        estado(b, '');
      });
  });
})();
